import {DEF} from "../../const.ts";
import {Dayjs} from "dayjs";

export interface GoodFilterInterface {
    epid: string | null;
    owner: string | null;
    description: string | null;
    dateFrom: Dayjs | null;
    dateTo: Dayjs | null;
    goodAddress: string | null;
    pointsFrom: number | null;
    pointsTo: number | null;
    goodStage: string | null;
    limit: number;
    offset: number;
}

export class GoodFilterBuilder {
    static readonly DEFAULT_LIMIT = 10000;
    static readonly DEFAULT_OFFSET = 0;

    private filter: GoodFilterInterface = {
        epid: null,
        owner: null,
        description: null,
        dateFrom: DEF.DEFAULT_DATE_FROM,
        dateTo: DEF.DEFAULT_DATE_TO,
        goodAddress: null,
        pointsFrom: null,
        pointsTo: null,
        goodStage: null,
        limit: GoodFilterBuilder.DEFAULT_LIMIT,
        offset: GoodFilterBuilder.DEFAULT_OFFSET
    };

    epid(epid: string | null): GoodFilterBuilder {
        this.filter.epid = epid?.length ? epid : null;
        return this;
    }

    owner(owner: string | null): GoodFilterBuilder {
        this.filter.owner = owner?.length ? owner : null;
        return this;
    }

    description(description: string | null): GoodFilterBuilder {
        this.filter.description = description?.length ? description : null;
        return this;
    }

    dateFrom(dateFrom: Dayjs | null): GoodFilterBuilder {
        this.filter.dateFrom = dateFrom;
        return this;
    }

    dateTo(dateTo: Dayjs | null): GoodFilterBuilder {
        this.filter.dateTo = dateTo;
        return this;
    }

    goodAddress(goodAddress: string | null): GoodFilterBuilder {
        this.filter.goodAddress = goodAddress?.length ? goodAddress : null;
        return this;
    }

    pointsFrom(pointsFrom: number | null): GoodFilterBuilder {
        this.filter.pointsFrom = pointsFrom;
        return this;
    }

    pointsTo(pointsTo: number | null): GoodFilterBuilder {
        this.filter.pointsTo = pointsTo;
        return this;
    }

    goodStage(goodStage: string | null): GoodFilterBuilder {
        this.filter.goodStage = goodStage?.length ? goodStage : null;
        return this;
    }

    limit(limit: number): GoodFilterBuilder {
        this.filter.limit = limit;
        return this;
    }

    offset(offset: number): GoodFilterBuilder {
        this.filter.offset = offset;
        return this;
    }

    build(): GoodFilterInterface {
        return {...this.filter};
    }

    reset(): GoodFilterBuilder {
        this.filter = {
            epid: null,
            owner: null,
            description: null,
            dateFrom: DEF.DEFAULT_DATE_FROM,
            dateTo: DEF.DEFAULT_DATE_TO,
            goodAddress: null,
            pointsFrom: null,
            pointsTo: null,
            goodStage: null,
            limit: GoodFilterBuilder.DEFAULT_LIMIT,
            offset: GoodFilterBuilder.DEFAULT_OFFSET
        };
        return this;
    }
}

